// 基本配置
export const basicConfig = {
    centerPointLongitude: '113.216596', // 中心点经度
    centerPointLatitude: '22.913121', // 中心点纬度
    mapZoom: 15 // 地图级别
};
